"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
var roosterjs_editor_dom_1 = require("roosterjs-editor-dom");
var ColorAttributeEnum;
(function (ColorAttributeEnum) {
    ColorAttributeEnum[ColorAttributeEnum["CssColor"] = 0] = "CssColor";
    ColorAttributeEnum[ColorAttributeEnum["HtmlColor"] = 1] = "HtmlColor";
    ColorAttributeEnum[ColorAttributeEnum["CssDataSet"] = 2] = "CssDataSet";
    ColorAttributeEnum[ColorAttributeEnum["HtmlDataSet"] = 3] = "HtmlDataSet";
})(ColorAttributeEnum || (ColorAttributeEnum = {}));
var ColorAttributeName = [
    (_a = {},
        _a[0 /* CssColor */] = 'color',
        _a[1 /* HtmlColor */] = 'color',
        _a[2 /* CssDataSet */] = "ogsc" /* OriginalStyleColor */,
        _a[3 /* HtmlDataSet */] = "ogac" /* OriginalAttributeColor */,
        _a),
    (_b = {},
        _b[0 /* CssColor */] = 'background-color',
        _b[1 /* HtmlColor */] = 'bgcolor',
        _b[2 /* CssDataSet */] = "ogsb" /* OriginalStyleBackgroundColor */,
        _b[3 /* HtmlDataSet */] = "ogab" /* OriginalAttributeBackgroundColor */,
        _b),
];
/**
 * @internal
 * Edit and transform color of elements between light mode and dark mode
 * @param core The EditorCore object
 * @param rootNode The root HTML elements to transform
 * @param includeSelf True to transform the root node as well, otherwise false
 * @param callback The callback function to invoke before do color transformation
 * @param direction To specify the transform direction, light to dark, or dark to light
 */
exports.transformColor = function (core, rootNode, includeSelf, callback, direction) {
    var elementsToTransform = core.lifecycle.isDarkMode ? getAll(rootNode, includeSelf) : [];
    var transformFunction = direction == 1 /* DarkToLight */
        ? transformToLightMode
        : core.lifecycle.onExternalContentTransform ||
            (function (element) { return transformToDarkMode(element, core.lifecycle.getDarkColor); });
    callback === null || callback === void 0 ? void 0 : callback();
    elementsToTransform.forEach(function (element) { return (element === null || element === void 0 ? void 0 : element.dataset) && element.style && transformFunction(element); });
};
function transformToLightMode(element) {
    ColorAttributeName.forEach(function (names) {
        // Reset color styles based on the content of the ogsc/ogsb data element.
        // If those data properties are empty or do not exist, set them anyway to clear the content.
        element.style.setProperty(names[0 /* CssColor */], getValueOrDefault(element.dataset[names[2 /* CssDataSet */]], ''));
        delete element.dataset[names[2 /* CssDataSet */]];
        // Some elements might have set attribute colors. We need to reset these as well.
        var value = element.dataset[names[3 /* HtmlDataSet */]];
        if (getValueOrDefault(value, null)) {
            element.setAttribute(names[1 /* HtmlColor */], value);
        }
        else {
            element.removeAttribute(names[1 /* HtmlColor */]);
        }
        delete element.dataset[names[3 /* HtmlDataSet */]];
    });
}
function transformToDarkMode(element, getDarkColor) {
    var computedValues = roosterjs_editor_dom_1.getComputedStyles(element, ['color', 'background-color']);
    ColorAttributeName.forEach(function (names, index) {
        var styleColor = element.style.getPropertyValue(names[0 /* CssColor */]);
        var attrColor = element.getAttribute(names[1 /* HtmlColor */]);
        if (!element.dataset[names[2 /* CssDataSet */]] &&
            !element.dataset[names[3 /* HtmlDataSet */]] &&
            (styleColor || attrColor)) {
            var newColor = getDarkColor(computedValues[index] || styleColor || attrColor);
            element.style.setProperty(names[0 /* CssColor */], newColor, 'important');
            element.dataset[names[2 /* CssDataSet */]] = styleColor || '';
            if (attrColor) {
                element.setAttribute(names[1 /* HtmlColor */], newColor);
                element.dataset[names[3 /* HtmlDataSet */]] = attrColor;
            }
        }
    });
}
function getValueOrDefault(value, defaultValue) {
    return value && value != 'undefined' && value != 'null' ? value : defaultValue;
}
function getAll(rootNode, includeSelf) {
    var result = [];
    if (roosterjs_editor_dom_1.safeInstanceOf(rootNode, 'HTMLElement')) {
        if (includeSelf) {
            result.push(rootNode);
        }
        var allChildren = rootNode.getElementsByTagName('*');
        roosterjs_editor_dom_1.arrayPush(result, roosterjs_editor_dom_1.toArray(allChildren));
    }
    else if (roosterjs_editor_dom_1.safeInstanceOf(rootNode, 'DocumentFragment')) {
        var allChildren = rootNode.querySelectorAll('*');
        roosterjs_editor_dom_1.arrayPush(result, roosterjs_editor_dom_1.toArray(allChildren));
    }
    return result;
}
//# sourceMappingURL=transformColor.js.map